module.exports = __webpack_public_path__ + "assets/img/show-w.c644946e.png";